export class SpellTargetNumber {
    public number = 0;
    public minLevel = 0;
    public featreq = '';
    recast() {
        return this;
    }
}
